/**
 * @file SessionAnnotationsDialog.jsx
 * @description opens a dialog to facilitate listing
 *              session annotations via SessionAnnotationsContainer.jsx.
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 27, 2023 13:55
 */
import { useDispatch, useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';

import SessionAnnotationsContainer from 'src/content/Document/Search/Sessions/SessionAnnotations/SessionAnnotationsContainer';

import {
    sessionAnnotationsDialogSet,
} from 'src/store/actions/sessionAnnotations/sessionAnnotationsPages.actions';

const useStyles = makeStyles(() => ({
    dialogPaper: {
        minHeight: '55vh',
        maxHeight: '55vh',
    },
}));

function SessionAnnotationsDialog() {
    const dispatch = useDispatch();
    const classes = useStyles();

    // start: redux state --------------------------
    const sessionAnnotationsPagesState = useSelector((state) => {
        return state.sessionAnnotationsPages;
    });

    const { sessionAnnotationsDialog } = sessionAnnotationsPagesState;
    // end: redux state -----------------------------

    const handleCloseDialog = () => {
        dispatch(sessionAnnotationsDialogSet(false));
    }

    return (
        <Dialog hideBackdrop open={sessionAnnotationsDialog}
            classes={{ paper: classes.dialogPaper }}
            onClose={handleCloseDialog}
            fullWidth maxWidth="lg"
            closeAfterTransition={false}
        >
            <DialogActions sx={{ marginBottom: '0px' }}>
                <Button variant="outlined" size="small" onClick={handleCloseDialog}>Close</Button>
            </DialogActions>

            <DialogTitle sx={{ marginLeft: '-5px', paddingTop: '0px', paddingBottom: '0px', marginBottom: '5px' }}>
                <Typography variant="h4" gutterBottom>
                    {'Session Annotations'}
                </Typography>
            </DialogTitle>

            <Divider variant="middle" />

            <DialogContent sx={{ paddingTop: '0px' }}>
                <SessionAnnotationsContainer />
            </DialogContent>

        </Dialog>
    )
}

export default SessionAnnotationsDialog;